import GUI from 'lil-gui';

export default class Controls {

    constructor(GAME, LEVELS) {

        this.gui = new GUI();

        this.environmentFolder = this.gui.addFolder('Environment');
        this.environmentFolder.add(GAME.config.wind, 'intensity').name('Wind intensity').min(0).max(1).step(0.1);
        this.environmentFolder.add(GAME.config.ball, 'launch_strength').name('Launch strength').min(0).max(GAME.config.ball.max_launch_strength).step(0.1);

        // -----------------------------
        // 🎨 Colours
        // -----------------------------
        this.colourFolder = this.gui.addFolder('Colours');
        this.colourFolder.addColor(GAME.config.paddingLeft, 'colour4').name('Left padding').onChange((colour) => {
            GAME.paddingLeftMesh.material.color.set(colour);
        });
        this.colourFolder.addColor(GAME.config.paddingRight, 'colour4').name('Right padding').onChange((colour) => {
            GAME.paddingRightMesh.material.color.set(colour);
        });
        this.colourFolder.close();

        // -----------------------------
        // 💡 Lights
        // -----------------------------
        this.lightFolder = this.gui.addFolder('Lights');
        this.lightFolder.addColor(GAME.config.lights.floor, 'colour').name('Floor colour').onChange(() => {
            GAME.LIGHTS.floorLight.color.set(GAME.config.lights.floor.colour);
        });
        this.lightFolder.add(GAME.config.lights.floor, 'intensity').name('Floor intensity').min(0).max(5).step(0.1).onChange(() => {
            GAME.LIGHTS.floorLight.intensity = GAME.config.lights.floor.intensity;
        })

        // -----------------------------
        // 🕓 Time
        // -----------------------------
        this.timeFolder = this.gui.addFolder('Time');
        this.timeFolder.add(GAME.TIME, 'pause').name('Pause');
        this.timeFolder.add(GAME.TIME, 'resume').name('Resume');

        // -----------------------------
        // 🎲 Game
        // -----------------------------
        this.gameFolder = this.gui.addFolder('Game');
        this.gameFolder.add(GAME.STATE, 'level').name('Level').min(1).max(LEVELS.length).step(1).onChange(() => { GAME.changeLevels() })
        this.gameFolder.add(GAME, 'reset').name('Reset Ball');
        this.gameFolder.add(GAME, 'clearState').name('Clear State');
        this.gameFolder.add(GAME, 'launch').name('Launch');

        if (window.innerWidth < 768) this.gui.close();

        this.environmentFolder.add(GAME.config.game, 'follow').name('Follow Ball');


    }
}
